import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const VerifyEmailOtp = createAsyncThunk(
  "VerifyEmailOtp",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.LOGIN.VERIFY_EMAIL_OTP,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const ForgetLoginPassword = createAsyncThunk(
  "ForgetLoginPassword",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.FORGET_PASSWORD,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const ChangeLoginPassword = createAsyncThunk(
  "ChangeLoginPassword",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CHANGE_PASSWORD,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const ResendEmailOtp = createAsyncThunk(
  "ResendEmailOtp",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.LOGIN.RESEND_EMAIL_OTP,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const SendEmailOtp = createAsyncThunk(
  "SendEmailOtp",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.LOGIN.SEND_EMAIL_OTP,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const SubscriberInviteLogin = createAsyncThunk(
  "SubscriberInviteLogin",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.LOGIN.SUBSCRIBERINVITELOGIN,
          body: data,
        },
        true  
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const getLoginDataUsingToken = createAsyncThunk(
  "getLoginDataUsingToken",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          // url: API_URL.BASEURL + API_URL.LOGIN.GETLOGINDATAUSINGTOKEN,
          url:
            API_URL.BASEURL +
            API_URL.LOGIN.GETLOGINDATAUSINGTOKEN +
            `?loginfrom=${data?.loginfrom}`,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetUserLoginLogList = createAsyncThunk(
  "GetUserLoginLogList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.LOGIN.USER_LOGIN_LOG_LIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  VerifyEmailOtpData: {
    data: null,
    error: null,
  },
  ForgetLoginPasswordData: {
    data: null,
    error: null,
  },
  ChangeLoginPasswordData: {
    data: null,
    error: null,
  },
  ResendEmailOtpData: {
    data: null,
    error: null,
  },
  SendEmailOtpData: {
    data: null,
    error: null,
  },
  SubscriberInviteLoginData: {
    data: null,
    error: null,
  },
  getLoginDataUsingTokenData: {
    data: null,
    error: null,
  },
  UserLoginLogListData: {
    data: null,
    error: null,
  },
};

const LoginSlice = createSlice({
  name: "LOGIN",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(VerifyEmailOtp.fulfilled, (state, action) => {
        state.VerifyEmailOtpData.data = action.payload;
      })
      .addCase(VerifyEmailOtp.rejected, (state, action) => {
        state.VerifyEmailOtpData.error = action.error.message;
      })
      .addCase(ForgetLoginPassword.fulfilled, (state, action) => {
        state.ForgetLoginPasswordData.data = action.payload;
      })
      .addCase(ForgetLoginPassword.rejected, (state, action) => {
        state.ForgetLoginPasswordData.error = action.error.message;
      })
      .addCase(ChangeLoginPassword.fulfilled, (state, action) => {
        state.ChangeLoginPasswordData.data = action.payload;
      })
      .addCase(ChangeLoginPassword.rejected, (state, action) => {
        state.ChangeLoginPasswordData.error = action.error.message;
      })
      .addCase(SendEmailOtp.fulfilled, (state, action) => {
        state.SendEmailOtpData.data = action.payload;
      })
      .addCase(SendEmailOtp.rejected, (state, action) => {
        state.SendEmailOtpData.error = action.error.message;
      })
      .addCase(SubscriberInviteLogin.fulfilled, (state, action) => {
        state.SubscriberInviteLoginData.data = action.payload;
      })
      .addCase(SubscriberInviteLogin.rejected, (state, action) => {
        state.SubscriberInviteLoginData.error = action.error.message;
      })
      .addCase(getLoginDataUsingToken.fulfilled, (state, action) => {
        state.getLoginDataUsingTokenData.data = action.payload;
      })
      .addCase(getLoginDataUsingToken.rejected, (state, action) => {
        state.getLoginDataUsingTokenData.error = action.error.message;
      })
      .addCase(GetUserLoginLogList.fulfilled, (state, action) => {
        state.UserLoginLogListData.data = action.payload;
      })
      .addCase(GetUserLoginLogList.rejected, (state, action) => {
        state.UserLoginLogListData.error = action.error.message;
      });
  },
});

export default LoginSlice.reducer;
